/**
 * @module store/modules/supervisor/state
 * @description Initial state for the Supervisor module.
 */

import { SupervisorState } from "./types";

/**
 * Initial state for supervisor dashboard.
 *
 * @type {SupervisorState}
 */
const state: SupervisorState = {
  currentMode: "",
  selectedDepartmentFilter: [],
  selectedChatSession: null,
  currentExpanded: null,
  selectedAgent: null,
  agentsWithChatCount: [],
  agentChatIds: {},

  inQueueChatsArray: [],
  onGoingChatsArray: [],
  abandonedChatsArray: [],
  resolvedChatsArray: [],

  inQueueChatCount: 0,
  onGoingChatCount: 0,
  abandonedChatCount: 0,
  resolvedChatCount: 0,

  inQueueChatLoading: true,
  onGoingChatLoading: true,
  abandonedChatLoading: true,
  resolvedChatLoading: true,
  agentListLoading: true,

  isLockOnLiveAnalytics: false,
};

export default state;
